import styled from "styled-components";
import {baseDistance, fontSize, radius, VerticalFlexStyle} from "../../../../styles/styles";
import {colorPalette} from "../../../../styles/colorPalette";
import {FilterFieldItem} from "../../../../filter/simple/SimpleFilterField.styled";
import {SearchFieldStyled} from "../../../../input/search/SearchField.styled";
import {SelectInputStyled} from "../../../../input/select/SelectInputV5";
import {LoaderStyled} from "../../../../loader/LoaderV5";
import {FieldElementsContainerStyled} from "../../../../details/Field.styled";
import {MultiSelectInputStyled} from "../../../../details/datatypes/multi/MultiSelect.styled";
import {MultiSelectOptionsWrapper} from "../../../../details/datatypes/multi/MultiSelectInputV5";
import {SelectedOptionStyled} from "../../../../input/search/SelectSearchFieldV5";
import {ReportDetailsStyled} from "./pages/details/ReportDetailsV5";

export const ReportWizardStyled = styled.div`
	${VerticalFlexStyle};
	align-items: center;
	justify-content: space-between;
	flex: 1;
	min-height: 0;
	gap: ${baseDistance.lg};

	.reportPage {
		display: flex;
		flex: 1;
		min-height: 0;
		width: 100%;
		max-width: 864px;
		justify-content: center;

		${ReportDetailsStyled} {
			max-width: 500px;
			margin-left: auto;
			margin-right: auto;
			align-self: center;
			display: flex;
			flex-direction: column;
			flex: 1;
			align-self: stretch;
			overflow-y: auto;

			.Field {
				padding: 5px;

				&.report-scope-portfolio-list {
					${VerticalFlexStyle};

					${FieldElementsContainerStyled} {
						min-height: 0;

						.element {
							min-height: 0;
							flex: 1;
							align-self: stretch;

							${MultiSelectInputStyled} {
								${VerticalFlexStyle};
								min-height: 0;

								${MultiSelectOptionsWrapper} {
									${VerticalFlexStyle};
									min-height: 0;
									flex: 1;

									${SelectedOptionStyled} {
										overflow-y: auto;
									}
								}
							}
						}
					}
				}

				&.currentPortfolio .element,
				.currentPortfolioLabel {
					font-size: ${fontSize.md};
					margin-left: ${baseDistance.sm};
					color: ${colorPalette.gray.c700Dark};
				}

				.element {
					width: 332px;
				}

				textarea,
				input {
					border: solid 1px ${colorPalette.gray.c300};
					border-radius: ${radius.sm};
					width: 100%;
					background-color: ${colorPalette.white};
					color: ${colorPalette.gray.c700Dark};
				}

				textarea {
					min-height: 32px;
					padding: 6px ${baseDistance.sm};
				}
			}
		}

		.btn-container {
			padding: ${baseDistance.sm};
			display: flex;
			flex-direction: row;
			justify-content: space-between;

			.clear-all {
				font-size: ${fontSize.md};
				color: ${colorPalette.gray.c400};
				cursor: pointer;
				padding-top: ${baseDistance.sm};
			}
		}

		&.customReportWizard {
			justify-content: flex-start;
			flex-direction: column;
			align-items: stretch;
			padding: ${baseDistance.sm};
		}
	}
`;

export const CustomReportWizardStyled = styled.div<{$noOutline?: boolean}>`
	align-items: flex-start;
	border: ${(props) => (props.$noOutline ? "none" : `1px solid ${colorPalette.gray.c400}`)} !important;
	border-radius: ${radius.sm};
	width: 620px;
	height: 312px;
	margin: ${baseDistance.md};

	${SelectInputStyled} {
		padding: ${baseDistance.sm};
	}

	${LoaderStyled} {
		width: 100%;
		height: 100%;
	}
`;

export const ButtonContainerStyled = styled.div`
	display: flex;
	align-self: end;
	gap: 10px;

	.saveDropdown {
		width: auto;
		background-color: ${colorPalette.primary.c500Primary};
		color: ${colorPalette.white};
		font-size: ${fontSize.md};

		&:hover {
			background-color: ${colorPalette.primary.c700Dark};
		}
	}
`;

export const ItemContainerStyled = styled.div`
	display: grid;
	gap: ${baseDistance.md};
	overflow-y: auto;
	overflow-x: hidden;
	padding: ${baseDistance.sm};
	margin-top: ${baseDistance.sm};

	.items {
		display: flex;
		gap: ${baseDistance.sm};
	}

	.CheckboxInputStyled {
		display: flex;
		align-items: center;
	}

	.label {
		text-align: right;
	}

	.noSearchResult {
		justify-content: center;
		display: flex;
	}
`;

export const FilterFieldItemStyled = styled.div`
	display: flex;
	justify-content: space-between;
	padding: ${baseDistance.sm};
	border-bottom: 1px solid ${colorPalette.gray.c300};
	flex-direction: column;
	gap: ${baseDistance.sm};

	${FilterFieldItem} {
		display: flex;
		align-items: center;
		gap: ${baseDistance.sm};
	}

	${SearchFieldStyled} {
		height: 32px;

		input {
			background: none;

			&:hover {
				background: none;
			}

			&:focus-visible {
				outline: none;
			}
		}
	}
`;

export const FilterFieldItemRowStyled = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
`;

export const FilterFieldItemGroupStyled = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	line-height: 32px;
`;
